import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getCustomerInfo } from '@kfc-global/react-shared/redux/Actions/OrderservAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ButtonComp } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import {
  getValueOrDefaultObject,
  getSafeString,
  getBackgroundImagePath,
  redirectToCateringPage,
  isCateringDisposition,
  getAndCheckIfOneTrue,
} from 'common/utilities/utils';
import FavOrderDetailSection from './FavOrderDetailSection';
import FavItemSection from '../../Presentation/FavoriteOrders/FavItemSection';
import RemoveFavouriteOrder from './RemoveFavouriteOrder';
import ReorderContainerGlobal from 'organisms/ReorderComponentGlobal/Container/ReorderContainer';
import {
  LOCAL_STORAGE_KEYS,
  REORDER_CONSTANTS,
  ROUTE_URL,
  SHARED_CONSTANTS,
  priceFixed_value,
  ANALYTICS_SHARED_CONSTANTS,
} from 'common/constants/SharedConstants';
import AddEditModalComponent from 'molecules/AddToFavourite/Container/AddEditModalComponent';
import { UserOrderContext } from 'context/context';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { viewFavMenu } from 'organisms/AccountPage/AU/Presentation/AccountAnalytics';
import ORDER_HISTORY from 'organisms/AccountPage/Constants/Constants';
import { localisationStartAnalytics } from 'common/utilities/analyticsUtils';

const fetchCustomerInfo = (tenantId, customerId, phoneNumber, dispatch) => {
  if (tenantId) {
    const payload = {
      customerId,
      tenantId,
      phoneNumber: getSafeString(phoneNumber),
      updateUserData: true,
    };
    dispatch(getCustomerInfo(payload));
  }
};
export const onClickHandler = (
  itemId,
  favoriteOrderData,
  productMapById,
  accordianParentElement,
  currencyConversionFactor,
) => {
  const { ACCOUNT_FAV_PAGE } = ORDER_HISTORY;
  accordianParentElement?.classList?.contains('account-accordian-open')
    ? accordianParentElement?.classList?.remove('account-accordian-open')
    : accordianParentElement?.classList?.add('account-accordian-open');
  const favItem = favoriteOrderData?.find(item => itemId === item?.id);

  const itemsArray = favItem?.items?.map((i, idx) => {
    const { categoryId: catId = 'NA', categoryName: catName = 'NA' } = productMapById?.[i.id] ?? {};
    return {
      item_name: i?.name,
      item_id: i?.id,
      price: getAndCheckIfOneTrue(Number((i?.price / currencyConversionFactor).toFixed(priceFixed_value)), 0),
      item_category: catName,
      item_list_name: ACCOUNT_FAV_PAGE,
      item_list_id: catId,
      index: idx,
      quantity: i?.quantity,
      coupon: getAndCheckIfOneTrue(favItem?.couponCode, 'NA'),
      discount: getAndCheckIfOneTrue(favItem?.discountTotal / currencyConversionFactor, 0),
      currency: ANALYTICS_SHARED_CONSTANTS.AUD,
    };
  });
  viewFavMenu(itemsArray);
};
const FavOrdersContainer = props => {
  const { updateMenu, imageContainerSize } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const [editItemId, setEditItemId] = useState('');
  const [occasionName, setOccasionName] = useState('');
  const [lastOccasionName, setLastOccasionName] = useState('');
  const [disaableButton, setDisableButton] = useState(true);
  const [occasionNameArr, setOccasionNameArr] = useState([]);
  const favoriteOrderData = useSelector(data => data.profileReducer?.favouriteOrders || []);
  const { id: customerId, phone: phoneNumber } = useSelector(data =>
    getValueOrDefaultObject(data.profileReducer?.basic),
  );
  const { tenantId, currencyConversionFactor } = useSelector(data => data.tenantReducer || {});
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { cartData } = useSelector(data => data.cartReducer || {});
  const [showOccassionModal, setOccassionModalOpen] = useState(false);
  const [isInValid, setIsInValid] = useState(false);
  const [isNameExist, setIsNameExist] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentItemId, setCurrentItemId] = useState(null);
  const { SingleArrowback, FavouriteActiveBlack } = IMAGE_PATH;
  const {
    reorderFlag: { reorderModalOpen = false },
  } = userOrderState;
  const [currentOrderInfo, setCurrentOrderInfo] = useState({});
  const { headerData: { plpBackgroundImage = {} } = {} } = useSelector(state =>
    getValueOrDefaultObject(state?.marketConfigReducer?.response),
  );
  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const plpbackgroundImageData = getBackgroundImagePath(plpBackgroundImage);
  const { REORDER_MODAL_OPEN, FROM_REORDER_MODAL_OPEN, REORDER_STORE_CHANGED } = START_ORDER_CONSTANTS;
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  const closeButtonHandler = () => {
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: false } });
    userOrderStateDispatch({ type: REORDER_STORE_CHANGED, value: { storeChanged: false } });
  };

  useEffect(() => {
    return () => closeButtonHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLastOccasionName(occasionName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showOccassionModal]);

  useEffect(() => {
    if (occasionName !== '' && !isInValid && !isNameExist) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [occasionName, isInValid, isNameExist]);

  const onEditOccasion = (id, occasion) => {
    setOccassionModalOpen(true);
    const occasionNameArray = [];
    favoriteOrderData?.map(item => occasionNameArray?.push(item?.name?.toUpperCase()?.trim()));
    setOccasionNameArr(occasionNameArray);
    if (id) {
      setEditItemId(id);
      setOccasionName(occasion);
      setIsInValid(false);
      setIsNameExist(false);
    }
  };

  const reorderBtnHandler = item => {
    !userParams?.localized && localisationStartAnalytics();
    setCurrentOrderInfo(item);
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: true } });
    userOrderStateDispatch({ type: FROM_REORDER_MODAL_OPEN, value: { fromReorderFlag: true } });
    /* setting true value to reorderClick, to avoid the toast onclick of reorder button */
    sessionStorage.setItem(LOCAL_STORAGE_KEYS.REORDER_CLICK, true);
  };

  useEffect(() => {
    fetchCustomerInfo(tenantId, customerId, phoneNumber, dispatch);
  }, [dispatch, tenantId, customerId, phoneNumber]);

  const redirectToCatering = params => {
    if (isCateringDisposition(cartData?.service)) {
      redirectToCateringPage(params);
    } else {
      userOrderStateDispatch({
        type: SHARED_CONSTANTS?.UPDATE_CATERING_RETAIL_MENU_ALERT,
        value: {
          flag: true,
          pathname: ROUTE_URL?.CATERING_PAGE,
          title: TRANSLATE_MAPPING_KEY?.CATERING_NAVALERT_TITLE,
          contentMsg: TRANSLATE_MAPPING_KEY?.CATERING_NAVALERT_SUBTITLE,
        },
      });
    }
  };

  const [currentIndex, setCurrentIndex] = useState(null);
  return (
    <div className='account-order-desktop' id='favourite-orders-global'>
      <div className='account-settings-header-mobile'>
        <img
          className='backArrow-account-setting'
          data-testid='fav-menu-backArrow'
          onClick={() => updateMenu('')}
          src={SingleArrowback}
          alt='back button'
        />
        <span className='account-setting-text-header'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.FAVOURITES)}</span>
      </div>
      <div className='page-header page-header-favourite-occasion'>
        <img src={FavouriteActiveBlack} className='account-icon mr-2' alt='' />
        <span className='page-heading'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_AGAIN)}</span>
      </div>
      {!favoriteOrderData?.length && (
        <div className='no-occasion-container'>
          <p>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.MY_OCCASSION_UNAVAILABLE_TITLE)}</p>
        </div>
      )}
      {favoriteOrderData &&
        favoriteOrderData?.map((item, index) => {
          return (
            <div className='sub-section sub-section-favourite'>
              <section>
                <section className='account-accordian'>
                  <FavOrderDetailSection
                    key={index}
                    onClickHandler={onClickHandler}
                    currencyConversionFactor={currencyConversionFactor}
                    title={item?.name}
                    onEditOccasionName={onEditOccasion}
                    itemId={item?.id}
                    itemName={item?.name}
                    data-testid='order-details'
                    setOccassionModalOpen={setOccassionModalOpen}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    index={index}
                    showContent={currentIndex === index}
                  >
                    <FavItemSection
                      occassionOrder={item}
                      tenantReducer={tenantReducer}
                      data-testid='occasion-component'
                      plpbackgroundImageData={plpbackgroundImageData}
                      imageContainerSize={imageContainerSize}
                    />
                    <section className='fav-menu-event'>
                      <div className='global-accordian-header-container mobile-accordian-reorder-container'>
                        <span className='global-accordian-header mobile-accordian-header'>
                          <span
                            className='order-receipt-option remove-from-fav'
                            data-testid='delete-occassion'
                            onClick={() => {
                              setIsModalOpen(true);
                              setCurrentItemId(item?.id);
                            }}
                          >
                            {translateWithI18Next(TRANSLATE_MAPPING_KEY?.REMOVE_FAVOURITES)}
                          </span>
                        </span>
                        <br />
                        <div className='global-accordian-right'>
                          <ButtonComp
                            className={`button re-order-btn ${isCateringDisposition(item?.service) ? '' : 'redButton'}`}
                            aria-label={''}
                            type='submit'
                            data-testid='re-order-btn'
                            onClick={() => {
                              isCateringDisposition(item?.service)
                                ? redirectToCatering({ ...props, history })
                                : reorderBtnHandler(item);
                            }}
                          >
                            <span>
                              {translateWithI18Next(
                                isCateringDisposition(item?.service)
                                  ? TRANSLATE_MAPPING_KEY?.EXPLORE_CATERING
                                  : TRANSLATE_MAPPING_KEY?.ORDER_AGAIN,
                              )}
                            </span>
                          </ButtonComp>
                        </div>
                      </div>
                    </section>
                  </FavOrderDetailSection>
                </section>

                {isModalOpen && (
                  <RemoveFavouriteOrder
                    item={item}
                    setIsModalOpen={setIsModalOpen}
                    isModalOpen={isModalOpen}
                    tenantId={tenantId}
                    customerId={customerId}
                    itemId={item?.id}
                    currentItemId={currentItemId}
                  />
                )}

                {showOccassionModal && (
                  <AddEditModalComponent
                    showOccassionModal={showOccassionModal}
                    setOccassionModalOpen={setOccassionModalOpen}
                    occasionName={occasionName}
                    setOccasionName={setOccasionName}
                    editItemId={editItemId}
                    setEditItemId={setEditItemId}
                    hasEdit={true}
                  />
                )}
              </section>
            </div>
          );
        })}
      {reorderModalOpen && (
        <ReorderContainerGlobal
          currentOrderInfo={currentOrderInfo}
          reorderModalOpen={reorderModalOpen}
          closeButtonHandler={closeButtonHandler}
          source={REORDER_CONSTANTS.ACCOUNT_FAVOURITES}
        />
      )}
    </div>
  );
};

export default FavOrdersContainer;
